import { BrowserMultiFormatReader } from "@zxing/library";
import classNames from "classnames";
import { useEffect, useMemo, useRef } from "react";
import styles from "./ScanBarcode.module.css";

export default function ScanBarcode({ onScan, className = "" }) {
  const ref = useRef(null);

  const codeReader = useMemo(() => {
    return new BrowserMultiFormatReader();
  }, []);

  useEffect(() => {
    if (!ref.current) {
      return;
    }

    codeReader.decodeFromVideoDevice(undefined, ref.current, result => {
      if (result) {
        onScan(result.getText());
      }
    });

    return () => {
      codeReader.reset();
    };
  }, []);

  return (
    <video
      ref={ref}
      className={classNames("border rounded w-100", styles.scanner, className)}
    />
  );
}
